/**
 * Detect the user's operating system from the browser user agent.
 * Returns null for mobile devices or unrecognizable UAs.
 */

export type DetectedOS = "macos" | "windows" | "linux";

export function detectOS(): DetectedOS | null {
  const ua = navigator.userAgent;

  // Exclude mobile before checking Linux (Android UA contains "Linux")
  if (/Android|iPhone|iPad|iPod/i.test(ua)) return null;

  if (/Macintosh|Mac OS X/i.test(ua)) return "macos";
  if (/Windows/i.test(ua)) return "windows";
  if (/Linux/i.test(ua)) return "linux";

  return null;
}
